<mat-sidenav-container autosize>
	<mat-sidenav (keydown.escape)="close('escape')"  (closed)="sidebarOpen = false" [mode]="mobileView ? 'push' : 'side'"
				 [ngClass]="user?.type === 'worker' ? 'worker-sidenav' : 'inet-sidenav'"
				 [opened]="sidebarOpen" role="navigation"  #sidenav>
		<app-sidebar *ngIf="user?.token || user?.globalSettings?.trackingOptions?.logo" [sidebarCollapsed]="sidebarCollapsed"
					 [toggleSidebarCollapsed]="toggleSidebarCollapsed"></app-sidebar>
	</mat-sidenav>
	<mat-sidenav-content class="sidenav-content">
		<div fxFlex fxLayout="column">
			<alert id="ERROR"></alert>
			<alert id="WARNING"></alert>
			<alert id="INFO"></alert>
			<div fxFlex fxLayout="column" fxLayoutGap="15px" [ngClass]="{'sidenav-content-shifted' : widgetShown}">
				<span [hidden]="true">
					<app-map class="map" id="mapPortalContent"></app-map>
				</span>
				<div *ngIf="user?.token" class="dynamic-header" fxLayout="row" fxLayoutAlign="start center"
					 fxLayoutGap="15px">
					<button (click)="toggleSidebarOpen()" class="sidebar-toggle" mat-icon-button>
						<mat-icon>menu</mat-icon>
					</button>
					<div class="page-title">{{currentPageTitle}}</div>
				</div>
				<div>
					<router-outlet [hidden]="pageLoading"></router-outlet>
				</div>
			</div>
			<app-footer fxFlexOffset="auto"></app-footer>
		</div>

	</mat-sidenav-content>
</mat-sidenav-container>
